<template>
  <div>
    <el-dialog
      title="用户详情"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
      center>
      <div v-if="userInfo">
        <div>
          <div class="group_27" style="display: flex;">
            <div class="group_28"></div>
            <div class="text_93">基本信息</div>
          </div>
          <div style="margin-left: 15px;">
            <el-form label-width="100px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="头像：">
                    <el-avatar :size="40" :src="userInfo.avatar" icon="el-icon-user-solid"></el-avatar>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="用户状态：">
                    <el-tag :type="getStatusTagType(userInfo.status)">{{userInfo.status | showStatus}}</el-tag>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="昵称：">
                    {{userInfo.nickname}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务号码：">
                    {{userInfo.serviceNumber || '--'}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item label="手机号码：">
                    {{userInfo.phone}}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div>
          <div class="group_27" style="display: flex; margin-top: 20px;">
            <div class="group_28"></div>
            <div class="text_93">地址信息</div>
          </div>
          <div style="margin-left: 15px;">
            <el-form label-width="100px">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item label="省份：">
                    {{userInfo.province || '--'}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="城市：">
                    {{userInfo.city || '--'}}
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="区县：">
                    {{userInfo.district || '--'}}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div>
          <div class="group_27" style="display: flex; margin-top: 20px;">
            <div class="group_28"></div>
            <div class="text_93">统计信息</div>
          </div>
          <div style="margin-left: 15px;">
            <el-form label-width="100px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="粉丝数：">
                    <span style="color: #409EFF; font-weight: 500;">{{userInfo.fansCount}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="关注数：">
                    <span style="color: #67C23A; font-weight: 500;">{{userInfo.followCount}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="商品数：">
                    <span style="color: #E6A23C; font-weight: 500;">{{userInfo.productCount}}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="信用分：">
                    <span :style="getCreditScoreStyle(userInfo.creditScore)">{{userInfo.creditScore}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <div>
          <div class="group_27" style="display: flex; margin-top: 20px;">
            <div class="group_28"></div>
            <div class="text_93">状态信息</div>
          </div>
          <div style="margin-left: 15px;">
            <el-form label-width="100px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="注册时间：">
                    {{userInfo.createTime}}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="更新时间：">
                    {{userInfo.updateTime}}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {axios} from "../../config/axios";

export default {
  name: "user-detail-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userId: {
      type: [Number, String],
      default: null
    },
    userData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      userInfo: null
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.userData) {
          // 如果直接传入了用户数据，直接使用
          this.userInfo = JSON.parse(JSON.stringify(this.userData));
        } else if (this.userId) {
          // 如果传入的是用户ID，需要获取用户详情
          this.getUserDetail(this.userId);
        }
      }
    }
  },
  methods: {
    handleClose() {
      this.userInfo = null;
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    // 根据用户ID获取用户详情
    getUserDetail(userId) {
      axios.get(`/app/user/${userId}`).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else {
          this.$message.error(res.message || '获取用户信息失败');
        }
      }).catch(err => {
        console.error(err);
        this.$message.error('获取用户信息失败');
      });
    },
    // 获取信用分样式
    getCreditScoreStyle(score) {
      if (score >= 90) {
        return { color: '#67C23A', fontWeight: 'bold' }; // 绿色
      } else if (score >= 70) {
        return { color: '#E6A23C', fontWeight: 'bold' }; // 橙色
      } else {
        return { color: '#F56C6C', fontWeight: 'bold' }; // 红色
      }
    },
    // 获取状态标签类型
    getStatusTagType(status) {
      switch(status) {
        case 1: return 'success'; // 正常
        case 2: return 'danger';  // 冻结
        case 3: return 'info';    // 注销
        default: return 'info';
      }
    }
  },
  filters: {
    // 显示用户状态
    showStatus(val){
      switch(val) {
        case 1: return "正常";
        case 2: return "冻结";
        case 3: return "注销";
        default: return "--";
      }
    }
  }
}
</script>

<style lang="less" scoped>
.group_27 {
  align-items: center;
  margin-bottom: 10px;
}

.group_28 {
  width: 4px;
  height: 16px;
  background-color: #409EFF;
  margin-right: 8px;
}

.text_93 {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
}
</style>
